// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-card-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.agreement {
  margin-top: 10px;
  max-width: 100%;
  display: flex;
  flex-direction: row;
}

.account-information-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  align-items: center;
}
.account-information-item button {
  line-height: normal;
}

::ng-deep .mat-input-element {
  margin-top: 5px !important;
}

::ng-deep .mat-form-field-infix {
  border: 0;
}

.mdc-dialog__title {
  padding-left: 0;
}

:host ::ng-deep .promo-code-field input {
  margin-top: 16px;
}
:host ::ng-deep .promo-code-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
:host ::ng-deep .agreement-text {
  line-height: 20px;
}
:host ::ng-deep .card-name input {
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/Settings/Account/account.scss"],"names":[],"mappings":"AAeA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAdJ;;AAgBA;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAbJ;;AAuCA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AApCJ;AAqCI;EACI,mBAAA;AAnCR;;AAuDA;EACI,0BAAA;AApDJ;;AAqEA;EACI,SAAA;AAlEJ;;AAsEA;EACI,eAAA;AAnEJ;;AAwEQ;EACI,gBAAA;AArEZ;AAuEQ;EACI,aAAA;AArEZ;AAyEI;EACI,iBAAA;AAvER;AA0EI;EACI,gBAAA;AAxER","sourcesContent":["// @import '../../styles.scss';\n@import \"../../variable/_variable.scss\";\n// @import \"../../component_variable.scss\";\n// h2{\n//     margin: 0;\n//     color: $primary-dark !important;\n//     font-weight: bold !important;\n// }\n\n// h3{\n//     margin: 0;\n//     color: $primary-dark !important;\n//     font-weight: bold !important;\n// }\n\n.add-card-header-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.agreement{\n    margin-top: 10px;\n    max-width: 100%;\n    display: flex;\n    flex-direction: row;\n}\n// .agreement-text{\n//     margin-left: 20px !important;\n//     color: $primary-dark !important;\n//     opacity: 56% !important;\n// }\n// .account-container{\n//     padding: 20px;\n//     margin: 20px;\n//     background-color: $primary-dark-background-color;\n//     border-radius: 8px;\n//     display: flex; \n//     flex-direction: column; \n//     justify-content: space-between;\n// }\n// .account-information{\n//     display: flex;\n//     flex-direction: row;\n//     justify-content: space-between;\n// }\n// .account-information-title{\n//     h3{\n//         color: $primary-dark;\n//     }\n// }\n.account-information-item{\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 16px;\n    align-items: center;\n    button{\n        line-height: normal;\n    }\n}\n// .detail{\n//     color: $primary-dark;\n//     font-weight: 500;\n//     font-size: 16px;\n// }\n// .info{\n//     color: $whizzimo-font-light;\n//     margin-left: 20px;\n//     font-size: 16px;\n//     font-weight: 500;\n// }\n// .divider{\n//     width: 100%;\n//     border-bottom: $whizzimo-border-transparent 1px solid;\n//     margin-top: 20px;\n//     margin-bottom: 20px;\n// }\n::ng-deep .mat-input-element{\n    margin-top: 5px !important;\n}\n\n// ::ng-deep .mat-mdc-dialog-container{\n//     border-radius: 8px;\n//     background-color: $whizzimo-modal-background;\n// }\n\n// .card-input{\n//     border-radius: 4px;\n//     width: 100% !important;\n//     height: 56px !important;\n//     font-size: 16px !important;\n//     color: $primary-dark;\n//     border: 1px solid $primary-dark !important;\n//     padding-left: 10px;\n// }\n::ng-deep .mat-form-field-infix{\n    border: 0;\n    \n}\n\n.mdc-dialog__title {\n    padding-left: 0;\n}\n\n:host ::ng-deep {\n    .promo-code-field {\n        input{\n            margin-top: 16px;\n        }\n        .mat-mdc-form-field-subscript-wrapper {\n            display: none;\n        }\n    }\n\n    .agreement-text {\n        line-height: 20px;\n    }\n\n    .card-name input {\n        margin-top: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
